import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { INomenclature } from './interface/INomenclature';

@Entity('nomenclature')
export class Nomenclature extends BaseEntity implements INomenclature {
  apiMapping = {
      noId: 'noId',
      noLibelle: 'noLibelle',
  };

  @PrimaryGeneratedColumn()
  noId: number;

  @Column()
  noLibelle: string;

  @Column({ nullable: true })
    isDeleted: boolean;
}
